"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Constants string for dataset names used by dark mode
 */
var DarkModeDatasetNames;
(function (DarkModeDatasetNames) {
    /**
     * Original style text color
     */
    DarkModeDatasetNames["OriginalStyleColor"] = "ogsc";
    /**
     * Original style background color
     */
    DarkModeDatasetNames["OriginalStyleBackgroundColor"] = "ogsb";
    /**
     * Original attribute text color
     */
    DarkModeDatasetNames["OriginalAttributeColor"] = "ogac";
    /**
     * Original attribute background color
     */
    DarkModeDatasetNames["OriginalAttributeBackgroundColor"] = "ogab";
})(DarkModeDatasetNames = exports.DarkModeDatasetNames || (exports.DarkModeDatasetNames = {}));
//# sourceMappingURL=DarkModeDatasetNames.js.map